// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".2e7bff7bab06db488903f8e3b618d3de257e3d45.chunk.js";
};